/*
 * @Author: Ryan
 * @Date: 2026-02-03
 * @Description: AI Image Enhancer 首屏展示图片数据
 */

import { ImageCompareItem } from '@/landing/components/ImageCompareSlider';

export const SHOWCASE_IMAGES: ImageCompareItem[] = [
  {
    id: 'jewelry-image',
    beforeUrl: 'https://assets.falcocut.ai/ai-image-enhancer/jewelry-image-before.webp',
    afterUrl: 'https://assets.falcocut.ai/ai-image-enhancer/jewelry-image-after.webp',
    thumbnailUrl: 'https://assets.falcocut.ai/ai-image-enhancer/jewelry-image-after.webp',
    label: 'Jewelry',
  },
  {
    id: 'house-image',
    beforeUrl: 'https://assets.falcocut.ai/ai-image-enhancer/house-image-before.webp',
    afterUrl: 'https://assets.falcocut.ai/ai-image-enhancer/house-image-after.webp',
    thumbnailUrl: 'https://assets.falcocut.ai/ai-image-enhancer/house-image-after.webp',
    label: 'House',
  },
  {
    id: 'dog-food-image',
    beforeUrl: 'https://assets.falcocut.ai/ai-image-enhancer/dog-food-image-before.webp',
    afterUrl: 'https://assets.falcocut.ai/ai-image-enhancer/dog-food-image-after.webp',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-image-enhancer/dog-food-image-after.webp',
    label: 'Product',
  },
  {
    id: 'selfie-social-image',
    beforeUrl:
      'https://assets.falcocut.ai/ai-image-enhancer/selfie-social-image-before.webp',
    afterUrl:
      'https://assets.falcocut.ai/ai-image-enhancer/selfie-social-image-after.webp',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-image-enhancer/selfie-social-image-after.webp',
    label: 'Selfie',
  },
  {
    id: 'document-image',
    beforeUrl: 'https://assets.falcocut.ai/ai-image-enhancer/document-image-before.webp',
    afterUrl: 'https://assets.falcocut.ai/ai-image-enhancer/document-image-after.webp',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-image-enhancer/document-image-after.webp',
    label: 'Document',
  },
];
